import axios, {AxiosRequestConfig} from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_DOMAIN;

interface IHttpRequest {
  method?: "GET" | "POST" | "PUT" | "DELETE";
  url: string;
  params?: any;
  data?: any;
  config?: AxiosRequestConfig<any>;
}

const ajaxHelper = async (opts: IHttpRequest) => {
  const {method, url, params, data, config} = opts;

  try {
    const res = await axios({
      url,
      method,
      params,
      data,
      ...(config ? config : {}),
    });

		if (res.status === 200 || res.status === 201) return res.data as any;
		if (res.status === 401) {
			window.location.reload();
			return;
		}

		return Promise.reject({
			statusCode: res.status,
			message: res.statusText,
			data: res.data?.data,
		});
	} catch (e: any) {
		if (e.response?.status === 401) {
			window.location.reload();
			return;
		}

    return Promise.reject({
      statusCode: e.response?.status || 500,
      message: e.response?.data ? e.response?.data : e.response?.statusText,
      data: e.response?.data?.data,
    });
  }
};

export const httpGET = (opts: IHttpRequest) => ajaxHelper({...opts, method: "GET"});

export const httpPOST = (opts: IHttpRequest) => ajaxHelper({...opts, method: "POST"});

export const httpPUT = (opts: IHttpRequest) => ajaxHelper({...opts, method: "PUT"});

export const httpDELETE = (opts: IHttpRequest) => ajaxHelper({...opts, method: "DELETE"});

export const httpDownload = async (opts: IHttpRequest) => {
  const {method, url, params, data, config} = opts;

  const link = document.createElement("a");
  link.target = "_blank";

  try {
    const res = await axios({
      url,
      method: method || "GET",
      params,
      data,
      responseType: "blob",
      ...(config ? config : {}),
    });

    // Check if file size is 0
    if (res.data.size === 0) {
      return Promise.reject({
        statusCode: 400,
        message: "There is no data shown to export.",
      });
    }

    link.href = URL.createObjectURL(new Blob([res.data], {type: res.headers["content-type"]}));

    let file_name = res.headers["content-disposition"]
      ?.split(";")
      .find((p: any) => p.toUpperCase().includes("FILENAME"));

    if (file_name) {
      link.download = file_name.split("=")[1].replace(/"/g, "");
    }

    link.click();

    return {statusCode: 200, message: "Success"};
  } catch (e: any) {
    return Promise.reject({
      statusCode: e.response?.status || 500,
      message: e.response?.data?.message ? e.response?.data?.message : e.response?.statusText,
      data: e.response?.data?.data,
    });
  }
};
